<template>
    <div class="auto-update-xlb-pannel">
        <div style="display: flex;align-items: center;">
            <!-- <div>
                <el-button type="primary" size="mini" @click="setOrderDialog = true">设置更新顺序</el-button>
            </div> -->
            <div style="margin-left: auto;"><i class="el-icon-refresh" style="cursor: pointer;color: #409EFF;"
                    @click="loadTable"></i></div>
        </div>
        <el-table :data="tableData" style="width: 100%;margin-top: 0.2rem" border size="mini" height="65vh"
            :header-cell-style="{
                background: '#ecf4ff',
                color: '#333',
                fontWeight: '900',
                fontSize: '0.28rem'
            }" element-loading-spinner="el-icon-loading" element-loading-background="rgba(0, 0, 0, 0.4)">
            <el-table-column prop="" label="序号" width="50" align="center">
                <template slot-scope="scope">
                    {{ scope.$index + 1 }}
                </template>
            </el-table-column>
            <el-table-column prop="" label="开始时间" align="center">
                <template slot-scope="scope">
                    <div>
                        <div>{{ scope.row.created_at }}</div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="" label="任务名称" align="center" width="188" show-overflow-tooltip>
                <template slot-scope="scope">
                    <div v-show="scope.row.task_describe">
                        <div :class="$style.taskDescribe">
                            {{ scope.row.task_describe }}
                        </div>
                        <div :class="$style.leftContainer">
                            <span>剩余待更新数量: </span>
                            <span :class="$style.leftCount">
                                {{ scope.row.task_count - scope.row.total_num }}
                            </span>
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="show_status" label="任务状态" align="center" width="188" show-overflow-tooltip>
                <template slot-scope="scope">
                    <span v-if="!scope.row.failed_reason">{{ scope.row.show_status }}</span>
                    <span :class="$style.errorColor" v-else>
                        <p>{{ scope.row.show_status }}</p>
                        <p>{{ scope.row.failed_reason }}</p>
                    </span>
                </template>
            </el-table-column>
            <el-table-column prop="total_num" label="执行总数" align="center" min-width="100">
                <template slot-scope="scope">
                    <div style="display: grid; grid-template-columns: auto 1fr;">
                        <div style="text-align: right; white-space: nowrap; overflow: hidden; text-overflow: ellipsis;width: 1rem;"
                            :title="scope.row.total_num">{{ scope.row.total_num }}</div>
                        <div style="text-align: left; white-space: nowrap; overflow: hidden; text-overflow: ellipsis; padding-left: 20px;width: 5rem;"
                            :title="scope.row.take_time ?
                                `耗时:${scope.row.take_time['hour']}小时${scope.row.take_time['minutes']}分` : '~'">(耗时:{{
                                    scope.row.take_time ?
                                        `${scope.row.take_time['hour']}小时${scope.row.take_time['minutes']}分` : '~' }})
                        </div>
                    </div>
                </template>
            </el-table-column>
            <el-table-column prop="success_num" label="号码获取成功数量" align="center">
            </el-table-column>
        </el-table>
        <div style="text-align: right;">
            <pagination-com :total="total" :perPage="pageSize" :npage="npage" @handleSizeChange="handleSizeChange"
                @handleCurrentChange="handleCurrentChange" />
        </div>

        <el-dialog :visible.sync="setOrderDialog" @close="closeDialog_set_order"
            @before-close="beforeCloseDialog_set_order" width="60%" center append-to-body>
            <template v-slot:title>
                <span id="dia-title">
                    设置更新顺序
                </span>
            </template>
            <div class="cal-tas-m-bg-con" v-if="setOrderDialog">
                <task-set-order />
            </div>
        </el-dialog>
    </div>
</template>

<script>
import PaginationCom from '../../../commonReform/PaginationCom';
const TaskSetOrder = () => import('./TaskSetOrder.vue')
export default {
    name: 'AutoUpdateXlbPannel',
    components: { PaginationCom, TaskSetOrder },
    data() {
        return {
            tableData: [],
            loading: false,
            pageSize: 30,
            total: 0,
            npage: 1,
            hyperfHost:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/v1/"
                    : "https://qyh-next-server.zhang66.cn/v1/",
            hyperfHostWithOutV1:
                process.env.NODE_ENV === "development"
                    ? "http://127.0.0.1:9501/"
                    : "https://qyh-next-server.zhang66.cn/",
            cate_id: null,
            setOrderDialog: false
        }
    },
    methods: {
        loadTable() {
            this.loading = true
            this.$axios.get(`${this.hyperfHostWithOutV1}qyh/call_task/autoUploadXlbPannelShow?page=${this.npage}`, {
                loadingClose: true,
                params: {
                    perPage: this.pageSize,
                    // cate_id: this.cateId
                    // searchArr: this.searchArr,
                },
            }).then(({ data }) => {
                if (data.code === 0) {
                    this.loading = false
                    this.tableData = data.data.data
                    this.total = data.data.total
                }
            }).catch()
        },
        handleSizeChange(val) {
            this.npage = 1;
            this.pageSize = val;
            this.loadTable();
        },
        handleCurrentChange(val) {
            this.npage = val;
            this.loadTable();
        },
        closeDialog_set_order() {
        },
        beforeCloseDialog_set_order() {
        },
    },
    watch: {
    },
    mounted() {
        this.loadTable()
    }
}
</script>

<style scoped>
#dia-title {
    font-size: large;
    font-weight: bold;
    color: #409EFF;
}
</style>
<style module>
.errorColor {
    color: #F56C6C;
}
.taskDescribe {
    color: #409EFF;
    font-size: medium;
}
.leftContainer {
    font-size: small;
}
.leftCount {
    color: #67C23A
}
</style>


// WEBPACK FOOTER //
// src/pages/cloudClue/Components/AutoUpdateXlbPannel.vue